import React from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useCategory } from '../../hooks/Features/useCategory'
import Category from './Category'

function EditCategory() {
  const params = useParams()

  const { getCategory, category } = useCategory()

  React.useEffect(() => {
    getCategory({ categoryId: params.categoryId })
  }, [params.categoryId])

  return <>{!category ? <Loader /> : <Category category={category} />}</>
}

export default EditCategory
